import { useState, useEffect } from 'react'
import Modal from '../Modal/Modal'
import CharacterModal from '../CharacterModal/CharacterModal'
import TabsModal from '../TabsModal/TabsModal'
import BanModal from '../BanModal/BanModal'
import API from '../../services/apiService'
import { 
  Skeleton, 
  SkeletonAvatar, 
  AccountInfoSkeleton, 
  CharacterListSkeleton 
} from '../Skeleton/Skeleton'
import LoadingOverlay from '../LoadingOverlay/LoadingOverlay'
import './ClientDetailsModal.css'

// Knight Avatar Icon for client
const KnightAvatarIcon = () => (
  <svg viewBox="0 0 64 64" width="56" height="56" className="client-details__avatar-icon">
    <defs>
      <linearGradient id="helmetGoldClient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#e6c84a"/>
        <stop offset="50%" stopColor="#c9a227"/>
        <stop offset="100%" stopColor="#8b6914"/>
      </linearGradient>
      <linearGradient id="helmetSteelClient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#c0c0c0"/>
        <stop offset="50%" stopColor="#a0a0a0"/>
        <stop offset="100%" stopColor="#707070"/>
      </linearGradient>
    </defs>
    <ellipse cx="32" cy="36" rx="22" ry="24" fill="url(#helmetSteelClient)" stroke="#505050" strokeWidth="1.5"/>
    <path d="M32 8 C18 8 12 20 12 32 L52 32 C52 20 46 8 32 8" fill="url(#helmetSteelClient)" stroke="#505050" strokeWidth="1.5"/>
    <rect x="28" y="4" width="8" height="8" rx="2" fill="url(#helmetGoldClient)" stroke="#8b6914" strokeWidth="1"/>
    <path d="M14 34 L50 34 L48 38 L16 38 Z" fill="#1a1a1a"/>
    <circle cx="22" cy="36" r="2" fill="#0a0a0a"/>
    <circle cx="42" cy="36" r="2" fill="#0a0a0a"/>
    <path d="M30 34 L34 34 L33 44 L31 44 Z" fill="url(#helmetSteelClient)" stroke="#505050" strokeWidth="0.5"/>
    <path d="M12 32 C12 32 22 28 32 28 C42 28 52 32 52 32" stroke="url(#helmetGoldClient)" strokeWidth="3" fill="none"/>
    <path d="M18 48 C18 56 46 56 46 48" fill="url(#helmetSteelClient)" stroke="#505050" strokeWidth="1"/>
    <circle cx="14" cy="40" r="3" fill="url(#helmetGoldClient)" stroke="#8b6914" strokeWidth="0.5"/>
    <circle cx="50" cy="40" r="3" fill="url(#helmetGoldClient)" stroke="#8b6914" strokeWidth="0.5"/>
  </svg>
)

// Tab Icon - Medieval Scroll
const TabIcon = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" className="client-details__info-icon">
    <defs>
      <linearGradient id="tabGoldClient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#e6c84a"/>
        <stop offset="100%" stopColor="#8b6914"/>
      </linearGradient>
    </defs>
    <rect x="4" y="4" width="16" height="16" rx="2" fill="none" stroke="url(#tabGoldClient)" strokeWidth="1.5"/>
    <line x1="4" y1="9" x2="20" y2="9" stroke="url(#tabGoldClient)" strokeWidth="1.5"/>
    <line x1="9" y1="4" x2="9" y2="9" stroke="url(#tabGoldClient)" strokeWidth="1.5"/>
    <circle cx="12" cy="15" r="2" fill="url(#tabGoldClient)"/>
  </svg>
)

// License Icon - Key
const LicenseIcon = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" className="client-details__info-icon">
    <defs>
      <linearGradient id="keyGoldClient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#e6c84a"/>
        <stop offset="100%" stopColor="#8b6914"/>
      </linearGradient>
    </defs>
    <circle cx="8" cy="8" r="5" fill="none" stroke="url(#keyGoldClient)" strokeWidth="1.5"/>
    <circle cx="8" cy="8" r="2" fill="url(#keyGoldClient)"/>
    <path d="M12 12 L20 20" stroke="url(#keyGoldClient)" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M17 17 L19 15" stroke="url(#keyGoldClient)" strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
)

// Calendar Icon
const CalendarIcon = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" className="client-details__info-icon">
    <defs>
      <linearGradient id="calGoldClient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#e6c84a"/>
        <stop offset="100%" stopColor="#8b6914"/>
      </linearGradient>
    </defs>
    <rect x="3" y="4" width="18" height="18" rx="2" fill="none" stroke="url(#calGoldClient)" strokeWidth="1.5"/>
    <line x1="16" y1="2" x2="16" y2="6" stroke="url(#calGoldClient)" strokeWidth="1.5" strokeLinecap="round"/>
    <line x1="8" y1="2" x2="8" y2="6" stroke="url(#calGoldClient)" strokeWidth="1.5" strokeLinecap="round"/>
    <line x1="3" y1="10" x2="21" y2="10" stroke="url(#calGoldClient)" strokeWidth="1.5"/>
  </svg>
)

// Email Icon
const EmailIcon = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" className="client-details__info-icon">
    <defs>
      <linearGradient id="emailGoldClient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#e6c84a"/>
        <stop offset="100%" stopColor="#8b6914"/>
      </linearGradient>
    </defs>
    <rect x="2" y="4" width="20" height="16" rx="2" fill="none" stroke="url(#emailGoldClient)" strokeWidth="1.5"/>
    <path d="M2 6 L12 13 L22 6" fill="none" stroke="url(#emailGoldClient)" strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
)

// Character Icon - Warrior
const CharacterIcon = () => (
  <svg viewBox="0 0 24 24" width="20" height="20" className="client-details__char-icon">
    <defs>
      <linearGradient id="charGoldClient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#e6c84a"/>
        <stop offset="100%" stopColor="#8b6914"/>
      </linearGradient>
    </defs>
    <circle cx="12" cy="7" r="4" fill="url(#charGoldClient)"/>
    <path d="M5 21 C5 15 8 12 12 12 C16 12 19 15 19 21" fill="url(#charGoldClient)"/>
    <path d="M12 4 L12 2" stroke="#c9a227" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M9 5 L7 3" stroke="#c9a227" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M15 5 L17 3" stroke="#c9a227" strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
)

// World Icon - Globe
const WorldIcon = () => (
  <svg viewBox="0 0 24 24" width="16" height="16" className="client-details__world-icon">
    <circle cx="12" cy="12" r="9" fill="none" stroke="#8b7355" strokeWidth="1.5"/>
    <ellipse cx="12" cy="12" rx="4" ry="9" fill="none" stroke="#8b7355" strokeWidth="1"/>
    <line x1="3" y1="12" x2="21" y2="12" stroke="#8b7355" strokeWidth="1"/>
    <path d="M4 8 Q12 6 20 8" fill="none" stroke="#8b7355" strokeWidth="0.75"/>
    <path d="M4 16 Q12 18 20 16" fill="none" stroke="#8b7355" strokeWidth="0.75"/>
  </svg>
)

// Level Icon - Star
const LevelIcon = () => (
  <svg viewBox="0 0 24 24" width="14" height="14" className="client-details__level-icon">
    <polygon points="12,2 15,9 22,9 17,14 19,21 12,17 5,21 7,14 2,9 9,9" fill="#c9a227" stroke="#8b6914" strokeWidth="1"/>
  </svg>
)

// Admin Actions Icon
const AdminActionsIcon = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" className="client-details__info-icon">
    <defs>
      <linearGradient id="adminActionsGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#fbbf24"/>
        <stop offset="100%" stopColor="#f59e0b"/>
      </linearGradient>
    </defs>
    <circle cx="12" cy="12" r="2" fill="url(#adminActionsGrad)"/>
    <circle cx="12" cy="5" r="2" fill="url(#adminActionsGrad)"/>
    <circle cx="12" cy="19" r="2" fill="url(#adminActionsGrad)"/>
  </svg>
)

// Shield Icon (Member Since)
const ShieldIcon = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" className="client-details__info-icon">
    <defs>
      <linearGradient id="shieldGoldClient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#e6c84a"/>
        <stop offset="100%" stopColor="#8b6914"/>
      </linearGradient>
    </defs>
    <path d="M12 2L3 6v6c0 5 4 9 9 11 5-2 9-6 9-11V6l-9-4z" fill="none" stroke="url(#shieldGoldClient)" strokeWidth="1.5" strokeLinejoin="round"/>
    <path d="M12 2v20" stroke="url(#shieldGoldClient)" strokeWidth="1.5" opacity="0.3"/>
    <text x="12" y="15" textAnchor="middle" fill="url(#shieldGoldClient)" fontSize="8" fontWeight="bold">i</text>
  </svg>
)

// Clock Login Icon (Last Login)
const ClockLoginIcon = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" className="client-details__info-icon">
    <defs>
      <linearGradient id="clockGoldClient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#e6c84a"/>
        <stop offset="100%" stopColor="#8b6914"/>
      </linearGradient>
    </defs>
    <circle cx="12" cy="12" r="9" fill="none" stroke="url(#clockGoldClient)" strokeWidth="1.5"/>
    <path d="M12 7v5l3 3" fill="none" stroke="url(#clockGoldClient)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M4 4l3 3M20 4l-3 3" stroke="url(#clockGoldClient)" strokeWidth="1.2" strokeLinecap="round" opacity="0.6"/>
  </svg>
)

// Gears Icon (Bot Configs)
const GearsIcon = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" className="client-details__info-icon">
    <defs>
      <linearGradient id="gearsGoldClient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#e6c84a"/>
        <stop offset="100%" stopColor="#8b6914"/>
      </linearGradient>
    </defs>
    <circle cx="10" cy="10" r="3" fill="none" stroke="url(#gearsGoldClient)" strokeWidth="1.5"/>
    <circle cx="10" cy="10" r="1" fill="url(#gearsGoldClient)"/>
    <path d="M10 4V2M10 18v-2M4 10H2M18 10h-2M5.5 5.5l-1-1M14.5 14.5l1 1M5.5 14.5l-1 1M14.5 5.5l1-1" stroke="url(#gearsGoldClient)" strokeWidth="1.2" strokeLinecap="round"/>
    <circle cx="17" cy="16" r="2.5" fill="none" stroke="url(#gearsGoldClient)" strokeWidth="1.2" opacity="0.7"/>
    <circle cx="17" cy="16" r="0.8" fill="url(#gearsGoldClient)" opacity="0.7"/>
  </svg>
)

// IP Icon (Last Login IP)
const IpIcon = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" className="client-details__info-icon">
    <defs>
      <linearGradient id="ipGoldClient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#e6c84a"/>
        <stop offset="100%" stopColor="#8b6914"/>
      </linearGradient>
    </defs>
    <circle cx="12" cy="12" r="9" fill="none" stroke="url(#ipGoldClient)" strokeWidth="1.5"/>
    <path d="M12 3v18M3 12h18" stroke="url(#ipGoldClient)" strokeWidth="1" opacity="0.35"/>
    <circle cx="12" cy="12" r="3" fill="none" stroke="url(#ipGoldClient)" strokeWidth="1.5"/>
    <circle cx="12" cy="12" r="1.5" fill="url(#ipGoldClient)"/>
  </svg>
)

// Notes Icon (License Notes)
const NotesIcon = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" className="client-details__info-icon">
    <defs>
      <linearGradient id="notesGoldClient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#e6c84a"/>
        <stop offset="100%" stopColor="#8b6914"/>
      </linearGradient>
    </defs>
    <path d="M7 3h10l2 2v14a2 2 0 01-2 2H7a2 2 0 01-2-2V5l2-2z" fill="none" stroke="url(#notesGoldClient)" strokeWidth="1.5" strokeLinejoin="round"/>
    <path d="M9 9h6M9 13h6M9 17h4" stroke="url(#notesGoldClient)" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M9 3v2h6V3" fill="none" stroke="url(#notesGoldClient)" strokeWidth="1" strokeLinejoin="round"/>
  </svg>
)

// Devices Icon (Active Sessions)
const DevicesIcon = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" className="client-details__info-icon">
    <defs>
      <linearGradient id="devGold" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#fcd34d"/>
        <stop offset="50%" stopColor="#e6c84a"/>
        <stop offset="100%" stopColor="#8b6914"/>
      </linearGradient>
      <linearGradient id="devScreen" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" stopColor="#e8f4f8" stopOpacity="0.5"/>
        <stop offset="100%" stopColor="#b8d4e3" stopOpacity="0.3"/>
      </linearGradient>
      <linearGradient id="devPhone" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#e6c84a" stopOpacity="0.3"/>
        <stop offset="100%" stopColor="#8b6914" stopOpacity="0.2"/>
      </linearGradient>
      <filter id="devShadow">
        <feDropShadow dx="1" dy="1" stdDeviation="1" floodColor="#78350f" floodOpacity="0.3"/>
      </filter>
    </defs>
    <g filter="url(#devShadow)">
      <rect x="2" y="3" width="13" height="11" rx="1.5" fill="url(#devScreen)" stroke="url(#devGold)" strokeWidth="1.5"/>
      <rect x="3.5" y="4.5" width="10" height="6" rx="0.5" fill="url(#devPhone)" stroke="none"/>
      <line x1="7" y1="11.5" x2="10" y2="11.5" stroke="url(#devGold)" strokeWidth="0.8" strokeLinecap="round"/>
      <circle cx="8.5" cy="12.8" r="0.4" fill="url(#devGold)"/>
      <path d="M6 14v2.5M11 14v2.5M3.5 16.5h10" stroke="url(#devGold)" strokeWidth="1.3" strokeLinecap="round"/>
      <line x1="7.5" y1="14" x2="9.5" y2="14" stroke="none"/>
    </g>
    <g filter="url(#devShadow)">
      <rect x="16" y="5" width="6" height="14" rx="1.5" fill="url(#devPhone)" stroke="url(#devGold)" strokeWidth="1.5"/>
      <rect x="17.5" y="7" width="3" height="7" rx="0.3" fill="url(#devScreen)" stroke="none"/>
      <circle cx="19" cy="16" r="0.8" fill="url(#devGold)"/>
      <rect x="18" y="4.5" width="2" height="0.5" rx="0.2" fill="url(#devGold)" opacity="0.5"/>
    </g>
  </svg>
)

// Refresh Icon
const RefreshIcon = () => (
  <svg viewBox="0 0 24 24" width="16" height="16" className="client-details__refresh-icon">
    <path d="M21 12 A9 9 0 1 1 12 3" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M21 3 L21 9 L15 9" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

// Authenticated Image Component with Skeleton Loading
const AuthImage = ({ clientId, filename, alt, onLoad, onError, className }) => {
  const [imageSrc, setImageSrc] = useState(null)
  const [imageError, setImageError] = useState(false)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    let mounted = true
    let objectUrl = null

    const loadImage = async () => {
      setIsLoading(true)
      try {
        const result = await API.Images.get(clientId, filename)
        
        if (result.success && result.blob && mounted) {
          if (objectUrl) {
            URL.revokeObjectURL(objectUrl)
          }
          
          objectUrl = URL.createObjectURL(result.blob)
          setImageSrc(objectUrl)
          setImageError(false)
          setIsLoading(false)
          if (onLoad) onLoad()
        } else {
          setImageError(true)
          setIsLoading(false)
          if (onError) onError()
        }
      } catch (err) {
        if (mounted) {
          setImageError(true)
          setIsLoading(false)
          if (onError) onError()
        }
      }
    }

    if (clientId && filename) {
      setImageSrc(null)
      setImageError(false)
      setIsLoading(true)
      loadImage()
    }

    return () => {
      mounted = false
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl)
      }
    }
  }, [clientId, filename])

  if (isLoading) {
    return (
      <div className="client-details__char-avatar-skeleton-wrapper">
        <SkeletonAvatar size="48px" />
      </div>
    )
  }

  if (imageError || !imageSrc) {
    return null
  }

  return <img src={imageSrc} alt={alt} className={`${className} client-details__char-img-loaded`} />
}

const ClientDetailsModal = ({ isOpen, onClose, client, onClientUpdated }) => {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [success, setSuccess] = useState(null)
  const [activeTab, setActiveTab] = useState('info')
  
  // Client data states
  const [clientData, setClientData] = useState(null)
  const [license, setLicense] = useState(null)
  const [characters, setCharacters] = useState([])
  const [loadedImages, setLoadedImages] = useState({})
  const [onlineStatus, setOnlineStatus] = useState(null)
  
  // Character detail modal state
  const [selectedCharacter, setSelectedCharacter] = useState(null)
  const [characterModalOpen, setCharacterModalOpen] = useState(false)
  const [loadingCharacter, setLoadingCharacter] = useState(false)
  
  // Tabs modal state
  const [tabsModalOpen, setTabsModalOpen] = useState(false)
  
  // Ban modal state
  const [banModalOpen, setBanModalOpen] = useState(false)

  // Delete confirmation state
  const [deleteModalOpen, setDeleteModalOpen] = useState(false)
  const [deleteConfirmText, setDeleteConfirmText] = useState('')

  // Additional data states
  const [configSummary, setConfigSummary] = useState(null)
  const [sessionsHistory, setSessionsHistory] = useState([])

  // New modals state
  const [editDetailsModalOpen, setEditDetailsModalOpen] = useState(false)
  const [editUsername, setEditUsername] = useState('')
  const [editEmail, setEditEmail] = useState('')
  const [resetPasswordModalOpen, setResetPasswordModalOpen] = useState(false)
  const [resetPasswordValue, setResetPasswordValue] = useState('')
  const [showPassword, setShowPassword] = useState(false)
  const [editLicenseNotesModalOpen, setEditLicenseNotesModalOpen] = useState(false)
  const [editLicenseNotesValue, setEditLicenseNotesValue] = useState('')
  const [revokeModalOpen, setRevokeModalOpen] = useState(false)
  const [revokeConfirmText, setRevokeConfirmText] = useState('')

  // Fetch client data when modal opens
  useEffect(() => {
    if (isOpen && client) {
      fetchClientData()
      setActiveTab('info')
      setError(null)
      setSuccess(null)
    }
  }, [isOpen, client])

  const fetchClientData = async () => {
    if (!client?.id) return
    
    setLoading(true)
    setError(null)

    try {
      // Fetch client details, license, characters, config summary, and sessions in parallel
      const [licenseRes, charsRes, onlineStatusRes, configRes, sessionsRes] = await Promise.all([
        API.Licenses.getClientLicense(client.id),
        API.Characters.list(client.id),
        API.Auth.getOnlineStatusAdmin(client.id),
        API.Clients.getConfigSummary(client.id),
        API.Clients.getSessionsHistory(client.id)
      ])

      // Use client data passed in
      setClientData(client)

      if (licenseRes.success) {
        setLicense(licenseRes.data)
      }

      if (charsRes.success) {
        setCharacters(charsRes.data || [])
        setLoadedImages({})
      }
      if (onlineStatusRes.success && onlineStatusRes.data) {
        setOnlineStatus(onlineStatusRes.data)
      }
      if (configRes.success) {
        setConfigSummary(configRes.data)
      }
      if (sessionsRes.success) {
        setSessionsHistory(sessionsRes.data || [])
      }
    } catch (err) {
      console.error('Failed to fetch client data:', err)
      setError('Could not load client information')
    } finally {
      setLoading(false)
    }
  }

  const handleCharacterClick = async (char) => {
    setLoadingCharacter(true)
    try {
      const response = await API.Characters.getByNameWorld(char.name, char.world)
      
      if (response.success && response.data) {
        setSelectedCharacter(response.data)
        setCharacterModalOpen(true)
      } else {
        setSelectedCharacter({ name: char.name, world: char.world, ...char })
        setCharacterModalOpen(true)
      }
    } catch (err) {
      console.error('Failed to fetch character details:', err)
      setSelectedCharacter({ name: char.name, world: char.world, ...char })
      setCharacterModalOpen(true)
    } finally {
      setLoadingCharacter(false)
    }
  }

  const closeCharacterModal = () => {
    setCharacterModalOpen(false)
    setSelectedCharacter(null)
  }

  // Admin Actions
  const handleActivateClient = async () => {
    setError(null)
    const response = await API.Clients.activate(client.id)
    if (response.success) {
      setSuccess('Client activated successfully')
      setClientData(prev => ({ ...prev, isActive: true, inactiveReason: null, inactiveUntil: null }))
      if (onClientUpdated) onClientUpdated()
    } else {
      setError(response.error || 'Failed to activate client')
    }
  }

  const handleBanClick = () => {
    setBanModalOpen(true)
  }

  const handleBanConfirm = async (banData) => {
    setError(null)
    const response = await API.Clients.deactivate(client.id, banData.reason, banData.until)
    if (response.success) {
      setSuccess('Client banned successfully')
      setClientData(prev => ({ 
        ...prev, 
        isActive: false, 
        inactiveReason: banData.reason || null,
        inactiveUntil: banData.until || null
      }))
      if (onClientUpdated) onClientUpdated()
    } else {
      setError(response.error || 'Failed to ban client')
    }
  }

  const handleDeleteClick = () => {
    setDeleteConfirmText('')
    setDeleteModalOpen(true)
  }

  const handleVerifyEmail = async () => {
    setError(null)
    const response = await API.Clients.verifyEmail(client.id)
    if (response.success) {
      setSuccess('Email verified successfully')
      setClientData(prev => ({ ...prev, isEmailVerified: true }))
    } else {
      setError(response.error || 'Failed to verify email')
    }
  }

  const handleRevokeSessions = () => {
    setRevokeConfirmText('')
    setRevokeModalOpen(true)
  }

  const handleRevokeConfirm = async () => {
    setError(null)
    setRevokeModalOpen(false)
    const response = await API.Clients.revokeSessions(client.id)
    if (response.success) {
      setSuccess(response.message || 'Sessions revoked successfully')
      fetchClientData()
    } else {
      setError(response.error || 'Failed to revoke sessions')
    }
  }

  const handleEditDetails = async () => {
    setError(null)
    const response = await API.Clients.update(client.id, { username: editUsername, email: editEmail })
    if (response.success) {
      setSuccess('Client details updated successfully')
      setEditDetailsModalOpen(false)
      if (onClientUpdated) onClientUpdated()
      fetchClientData()
    } else {
      setError(response.error || 'Failed to update client')
    }
  }

  const handleResetPassword = async () => {
    if (!resetPasswordValue || resetPasswordValue.length < 6) {
      setError('Password must be at least 6 characters')
      return
    }
    setError(null)
    const response = await API.Clients.resetPassword(client.id, resetPasswordValue)
    if (response.success) {
      setSuccess('Password reset successfully')
      setResetPasswordModalOpen(false)
      setResetPasswordValue('')
    } else {
      setError(response.error || 'Failed to reset password')
    }
  }

  const handleEditLicenseNotes = async () => {
    setError(null)
    const response = await API.Clients.updateLicenseNotes(client.id, editLicenseNotesValue)
    if (response.success) {
      setSuccess('License notes updated successfully')
      setEditLicenseNotesModalOpen(false)
      fetchClientData()
    } else {
      setError(response.error || 'Failed to update license notes')
    }
  }

  const handleDeleteConfirm = async () => {
    if (deleteConfirmText !== client.username) {
      setError('Username does not match. Please type the exact username to confirm.')
      return
    }

    const response = await API.Clients.delete(client.id)
    if (response.success) {
      setDeleteModalOpen(false)
      if (onClientUpdated) onClientUpdated()
      onClose()
    } else {
      setError(response.error || 'Failed to delete client')
    }
  }

  const formatDate = (dateString) => {
    if (!dateString) return 'Never'
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    })
  }

  const formatShortDate = (dateString) => {
    if (!dateString) return 'N/A'
    return new Date(dateString).toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    })
  }

  const getTotalTabs = () => {
    if (!license) return 0
    return license.summary?.totalAvailableTabs || license.totalAvailableTabs || (license.tabs || 0)
  }

  const getLicenseStatus = () => {
    if (!license) return { text: 'Free', class: 'free' }
    const tabs = getTotalTabs()
    if (tabs > 0) return { text: 'Licensed', class: 'premium' }
    return { text: 'Free', class: 'free' }
  }

  const getAccountStatus = () => {
    if (!clientData) return { text: 'Unknown', class: 'unknown' }
    if (clientData.isActive) return { text: 'Active', class: 'active' }
    if (!clientData.isEmailVerified) return { text: 'Inactive', class: 'inactive' }
    if (clientData.inactiveUntil) return { text: 'Suspended', class: 'suspended' }
    return { text: 'Banned', class: 'banned' }
  }

  if (!client) return null

  const licenseStatus = getLicenseStatus()
  const accountStatus = getAccountStatus()

  return (
    <>
      <Modal 
        isOpen={isOpen} 
        onClose={onClose} 
        title="👤 Client Details"
        modalClassName="client-details-modal"
      >
        <div className="client-details">
          {/* Header with Avatar */}
          <div className="client-details__header">
            <div className="client-details__avatar">
              <KnightAvatarIcon />
            </div>
            <div className="client-details__name">
              <h3 className="client-details__username">
                {client.isAdmin && (
                  <span className="client-details__crown" aria-hidden>
                    <svg viewBox="0 0 24 24" width="20" height="20">
                      <defs>
                        <linearGradient id="crownGoldClient" x1="0%" y1="0%" x2="100%" y2="100%">
                          <stop offset="0%" stopColor="#fde68a" />
                          <stop offset="50%" stopColor="#fbbf24" />
                          <stop offset="100%" stopColor="#f59e0b" />
                        </linearGradient>
                      </defs>
                      <path d="M2 17l3-7 4 4 5-10 4 7 4-4v11H2z" fill="url(#crownGoldClient)" stroke="#92400e" strokeWidth="0.8"/>
                      <circle cx="5" cy="10" r="1.5" fill="#ef4444" stroke="#92400e" strokeWidth="0.5"/>
                      <circle cx="12" cy="7" r="1.8" fill="#ef4444" stroke="#92400e" strokeWidth="0.5"/>
                      <circle cx="19" cy="10" r="1.5" fill="#ef4444" stroke="#92400e" strokeWidth="0.5"/>
                    </svg>
                  </span>
                )}
                {client.username}
                {client.nickname && (
                  <span className="client-details__nickname">aka "{client.nickname}"</span>
                )}
              </h3>
              <div className="client-details__badges">
                <span className={`client-details__badge client-details__badge--${licenseStatus.class}`}>
                  ⚔️ {loading ? '...' : licenseStatus.text}
                </span>
                <span className={`client-details__badge client-details__badge--${accountStatus.class}`}>
                  {accountStatus.text}
                </span>
                {client.isAdmin && (
                  <span className="client-details__badge client-details__badge--admin">👑 Admin</span>
                )}
                {onlineStatus && (
                  <>
                    <span className={`account__badge account__badge--status account__badge--status-${onlineStatus.isAppOnline ? 'online' : 'offline'}`}
                          title="APP (Unity-BOT)">
                      <span className="account__status-dot"></span>
                      APP: {onlineStatus.isAppOnline ? 'Online' : 'Offline'}
                    </span>
                    <span className={`account__badge account__badge--status account__badge--status-${onlineStatus.isSiteOnline ? 'online' : 'offline'}`}
                          title="Site (Website)">
                      <span className="account__status-dot"></span>
                      Site: {onlineStatus.isSiteOnline ? 'Online' : 'Offline'}
                    </span>
                  </>
                )}
              </div>
            </div>
          </div>

          {/* Tabs Navigation */}
          <div className="client-details__tabs">
            <button 
              className={`client-details__tab ${activeTab === 'info' ? 'client-details__tab--active' : ''}`}
              onClick={() => setActiveTab('info')}
            >
              <LicenseIcon /> Info
            </button>
            <button 
              className={`client-details__tab ${activeTab === 'characters' ? 'client-details__tab--active' : ''}`}
              onClick={() => setActiveTab('characters')}
            >
              <CharacterIcon /> Characters
              {characters.length > 0 && (
                <span className="client-details__tab-count">{characters.length}</span>
              )}
            </button>
            <button 
              className={`client-details__tab ${activeTab === 'sessions' ? 'client-details__tab--active' : ''}`}
              onClick={() => setActiveTab('sessions')}
            >
              <DevicesIcon /> Sessions
              {sessionsHistory.filter(s => !s.isRevoked).length > 0 && (
                <span className="client-details__tab-count">{sessionsHistory.filter(s => !s.isRevoked).length}</span>
              )}
            </button>
            <button 
              className={`client-details__tab ${activeTab === 'actions' ? 'client-details__tab--active' : ''}`}
              onClick={() => setActiveTab('actions')}
            >
              <AdminActionsIcon /> Actions
            </button>
          </div>

          {/* Error Message */}
          {error && (
            <div className="client-details__error">
              <span>⚠️ {typeof error === 'object' ? error?.message || 'An error occurred' : error}</span>
              <button onClick={() => setError(null)}>×</button>
            </div>
          )}

          {/* Success Message */}
          {success && (
            <div className="client-details__success">
              <span>✅ {success}</span>
              <button onClick={() => setSuccess(null)}>×</button>
            </div>
          )}

          {/* Content Area */}
          {loading ? (
            <div className="client-details__content-skeleton">
              {activeTab === 'info' && <AccountInfoSkeleton />}
              {activeTab === 'characters' && <CharacterListSkeleton count={3} />}
              {activeTab === 'actions' && <AccountInfoSkeleton />}
            </div>
          ) : (
            <div className="client-details__content-loaded">
              {/* Info Tab */}
              {activeTab === 'info' && (
                <div className="client-details__info">
                  {/* Email */}
                  <div className="client-details__info-item">
                    <EmailIcon />
                    <span className="client-details__info-label">Email:</span>
                    <span className="client-details__info-value">{clientData?.email || client.email || '—'}</span>
                  </div>

                  {/* Account Status */}
                  <div className="client-details__info-item">
                    <svg viewBox="0 0 24 24" width="18" height="18" className="client-details__info-icon">
                      <defs>
                        <linearGradient id="statusIconGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                          <stop offset="0%" stopColor="#e6c84a"/>
                          <stop offset="100%" stopColor="#8b6914"/>
                        </linearGradient>
                      </defs>
                      <circle cx="12" cy="12" r="9" fill="none" stroke="url(#statusIconGrad)" strokeWidth="1.5"/>
                      <path d="M12 7v5l3 3" fill="none" stroke="url(#statusIconGrad)" strokeWidth="1.5" strokeLinecap="round"/>
                    </svg>
                    <span className="client-details__info-label">Status:</span>
                    <span className={`client-details__info-value client-details__info-value--${accountStatus.class}`}>
                      {accountStatus.text}
                    </span>
                  </div>

                  {/* Ban Reason (if banned) */}
                  {!clientData?.isActive && clientData?.inactiveReason && (
                    <div className="client-details__info-item client-details__info-item--sub">
                      <span className="client-details__info-label">└ Reason:</span>
                      <span className="client-details__info-value client-details__info-value--muted">
                        {clientData.inactiveReason}
                      </span>
                    </div>
                  )}

                  {/* Ban Until (if suspended) */}
                  {!clientData?.isActive && clientData?.inactiveUntil && (
                    <div className="client-details__info-item client-details__info-item--sub">
                      <span className="client-details__info-label">└ Until:</span>
                      <span className="client-details__info-value client-details__info-value--muted">
                        {formatDate(clientData.inactiveUntil)}
                      </span>
                    </div>
                  )}

                  {/* Available Tabs */}
                  <div className="client-details__info-item">
                    <TabIcon />
                    <span className="client-details__info-label">Available Tabs:</span>
                    <span className="client-details__info-value client-details__info-value--highlight">
                      {getTotalTabs()}
                        {(license?.summary?.totalAvailableNewtabs || 0) > 0 && (
                          <span className="client-details__temp-badge">+{license.summary?.totalAvailableNewtabs || license.totalActiveTempTabs || 0} temp</span>
                      )}
                    </span>
                  </div>

                  {/* Permanent Tabs */}
                    {license && (license.summary?.permanentTabs || license.totalPermanentTabs || license.tabs || 0) > 0 && (
                    <div className="client-details__info-item client-details__info-item--sub">
                      <span className="client-details__info-label">└ Permanent:</span>
                        <span className="client-details__info-value">{license.summary?.permanentTabs || license.totalPermanentTabs || license.tabs || 0}</span>
                    </div>
                  )}

                  {/* Last Modified By Admin */}
                  {license?.lastModifiedByAdminName && (
                    <div className="client-details__info-item client-details__info-item--sub">
                      <span className="client-details__info-label">└ Modified by:</span>
                      <span className="client-details__info-value client-details__info-value--admin">
                        {license.lastModifiedByAdminName}
                      </span>
                    </div>
                  )}

                  {/* NewTab Packages */}
                  {license?.newtabs && license.newtabs.length > 0 && (
                    <div className="client-details__packages">
                      <div className="client-details__packages-title">📦 Active Packages:</div>
                      {license.newtabs
                        .filter(nt => !nt.isExpired)
                        .map((nt, index) => (
                          <div key={nt.id || index} className="client-details__package">
                            <div className="client-details__package-main">
                              <span className="client-details__package-qty">{nt.quantity} tabs</span>
                              <span className="client-details__package-exp">expires {formatShortDate(nt.expiresAt)}</span>
                            </div>
                            {nt.description && (
                              <span className="client-details__package-desc">{nt.description}</span>
                            )}
                            {nt.lastModifiedByAdminName && (
                              <span className="client-details__package-admin" title="Added by admin">
                                👤 {nt.lastModifiedByAdminName}
                              </span>
                            )}
                          </div>
                        ))}
                    </div>
                  )}

                  {/* Member Since */}
                  <div className="client-details__info-item">
                    <ShieldIcon />
                    <span className="client-details__info-label">Member Since:</span>
                    <span className="client-details__info-value">{formatShortDate(clientData?.createdAt || client.createdAt)}</span>
                  </div>

                  {/* Last Login */}
                  <div className="client-details__info-item">
                    <ClockLoginIcon />
                    <span className="client-details__info-label">Last Login:</span>
                    <span className="client-details__info-value">{formatDate(clientData?.lastLoginAt || client.lastLoginAt)}</span>
                  </div>

                  {/* Last Activity */}
                  {(clientData?.lastActivityAt || client.lastActivityAt) && (
                    <div className="client-details__info-item">
                      <ClockLoginIcon />
                      <span className="client-details__info-label">Last Activity:</span>
                      <span className="client-details__info-value">{formatDate(clientData?.lastActivityAt || client.lastActivityAt)}</span>
                    </div>
                  )}

                  {/* Email Verified */}
                  <div className="client-details__info-item">
                    <EmailIcon />
                    <span className="client-details__info-label">Email Verified:</span>
                    <span className={`client-details__info-value client-details__info-value--${clientData?.isEmailVerified ? 'active' : 'inactive'}`}>
                      {clientData?.isEmailVerified ? '✅ Yes' : '❌ No'}
                    </span>
                  </div>

                  {/* Last Login IP */}
                  {(clientData?.lastLoginIp) && (
                    <div className="client-details__info-item">
                      <IpIcon />
                      <span className="client-details__info-label">Last IP:</span>
                      <span className="client-details__info-value">{clientData.lastLoginIp}</span>
                    </div>
                  )}

                  {/* Deactivated By Admin */}
                  {(clientData?.deactivatedByAdmin || clientData?.deactivatedByAdminName) && (
                    <div className="client-details__info-item client-details__info-item--sub">
                      <span className="client-details__info-label">└ Banned by:</span>
                      <span className="client-details__info-value client-details__info-value--admin">
                        {clientData.deactivatedByAdmin || clientData.deactivatedByAdminName}
                      </span>
                    </div>
                  )}

                  {/* Email Verification Attempts */}
                  {clientData?.emailVerificationAttempts > 0 && (
                    <div className="client-details__info-item">
                      <EmailIcon />
                      <span className="client-details__info-label">Verif. Attempts:</span>
                      <span className="client-details__info-value">{clientData.emailVerificationAttempts}</span>
                    </div>
                  )}

                  {/* License Notes */}
                  {license?.notes && (
                    <div className="client-details__info-item">
                      <NotesIcon />
                      <span className="client-details__info-label">License Notes:</span>
                      <span className="client-details__info-value client-details__info-value--muted">{license.notes}</span>
                    </div>
                  )}

                  {/* Character Count */}
                  {configSummary && (
                    <div className="client-details__info-item">
                      <CharacterIcon />
                      <span className="client-details__info-label">Characters:</span>
                      <span className="client-details__info-value">{configSummary.characters.total} ({configSummary.characters.online} online)</span>
                    </div>
                  )}

                  {/* Active Sessions */}
                  {sessionsHistory.length > 0 && (
                    <div className="client-details__info-item">
                      <DevicesIcon />
                      <span className="client-details__info-label">Active Sessions:</span>
                      <span className="client-details__info-value">
                        {sessionsHistory.filter(s => s.isActive).length} ({sessionsHistory.filter(s => s.isActive && s.type === 'app').length} APP / {sessionsHistory.filter(s => s.isActive && s.type === 'site').length} Site)
                      </span>
                    </div>
                  )}

                  {/* Bot Config Summary */}
                  {configSummary && (
                    <div className="client-details__info-item">
                      <GearsIcon />
                      <span className="client-details__info-label">Bot Configs:</span>
                      <span className="client-details__info-value">
                        TG: {configSummary.telegramConfigs} | 
                        Bind: {configSummary.bindConfigs.total} ({configSummary.bindConfigs.scripts}S/{configSummary.bindConfigs.sa}SA) | 
                        UC: {configSummary.unrealCredentials} | 
                        LI: {configSummary.lifeInsurancePreferences}
                      </span>
                    </div>
                  )}
                </div>
              )}

              {/* Sessions Tab */}
              {activeTab === 'sessions' && (
                <div className="client-details__sessions">
                  <h4 className="client-details__actions-title">
                    <DevicesIcon /> Active Sessions ({sessionsHistory.filter(s => !s.isRevoked).length})
                  </h4>
                  {sessionsHistory.length === 0 ? (
                    <p className="account__config-empty">No session history</p>
                  ) : (
                    <div className="client-details__sessions-list">
                      {sessionsHistory.map((s, i) => (
                        <div key={s.id || i} className={`client-details__session-item ${s.isRevoked ? 'client-details__session-item--revoked' : ''}`}>
                          <div className="client-details__session-header">
                            <span className={`client-details__session-status-dot ${s.isRevoked ? 'offline' : 'online'}`} />
                            <strong>{s.type || 'unknown'}</strong>
                            <span className="client-details__session-status-label">
                              {s.isRevoked ? 'Revoked' : 'Active'}
                            </span>
                          </div>
                          <div className="client-details__session-details">
                            {s.userAgent && <span title="Device/Browser">{s.userAgent.substring(0, 60)}</span>}
                            {s.ipAddress && <span title="IP Address">IP: {s.ipAddress}</span>}
                            {s.lastUsedAt && <span>Last: {formatDate(s.lastUsedAt)}</span>}
                            {s.createdAt && <span>Created: {formatDate(s.createdAt)}</span>}
                            {s.revokedAt && <span>Revoked: {formatDate(s.revokedAt)}</span>}
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              )}

              {/* Characters Tab */}
              {activeTab === 'characters' && (
                <div className="client-details__characters">
                  {loadingCharacter && (
                    <LoadingOverlay label="Loading characters">
                      <div className="client-details__loading-skeleton">
                        <SkeletonAvatar size="60px" />
                        <div className="client-details__loading-skeleton-text">
                          <Skeleton width="150px" height="18px" />
                          <Skeleton width="100px" height="14px" style={{ marginTop: '8px' }} />
                        </div>
                      </div>
                    </LoadingOverlay>
                  )}
                  {characters.length === 0 ? (
                    <div className="client-details__no-chars">
                      <CharacterIcon />
                      <p>No characters found</p>
                      <span>Characters will appear here when created in-game</span>
                    </div>
                  ) : (
                    <div className="client-details__char-list">
                      {characters.map((char, index) => {
                        const clientId = client.id
                        const imageName = char.name && char.world 
                          ? `${char.name.toLowerCase().replace(/\s+/g, '_')}_${char.world.toLowerCase().replace(/\s+/g, '_')}`
                          : null
                        const imageKey = `${char.id || index}_${imageName}`
                        const imageLoaded = loadedImages[imageKey]
                        
                        return (
                          <div 
                            key={char.id || index} 
                            className="client-details__char-card client-details__char-card--clickable"
                            onClick={() => handleCharacterClick(char)}
                            title="Click to view details"
                          >
                            <div className="client-details__char-avatar">
                              {clientId && imageName ? (
                                <AuthImage
                                  clientId={clientId}
                                  filename={imageName}
                                  alt={char.name}
                                  className="client-details__char-avatar-img"
                                  onLoad={() => setLoadedImages(prev => ({ ...prev, [imageKey]: true }))}
                                  onError={() => setLoadedImages(prev => ({ ...prev, [imageKey]: false }))}
                                />
                              ) : (
                                <div className="client-details__char-fallback">
                                  <SkeletonAvatar size="48px" />
                                </div>
                              )}
                              {clientId && imageName && imageLoaded === false && (
                                <div className="client-details__char-fallback">
                                  <SkeletonAvatar size="48px" />
                                </div>
                              )}
                            </div>
                            <div className="client-details__char-info">
                              <div className="client-details__char-header">
                                <span className="client-details__char-name">{char.name}</span>
                                <span className={`client-details__char-status client-details__char-status--${char.online ? 'online' : 'offline'}`}>
                                  <span className="client-details__char-status-dot"></span>
                                  {char.online ? 'Online' : 'Offline'}
                                </span>
                              </div>
                              <div className="client-details__char-details">
                                <span className="client-details__char-world">
                                  <WorldIcon /> {char.world || 'Unknown'}
                                </span>
                                {(char.level || char.gameData?.level) && (
                                  <span className="client-details__char-level">
                                    <LevelIcon /> Level {char.level || char.gameData?.level}
                                  </span>
                                )}
                              </div>
                              {(char.gameData?.vocation || char.vocation) && (
                                <div className="client-details__char-vocation">
                                  {char.gameData?.vocation || char.vocation}
                                </div>
                              )}
                            </div>
                            <div className="client-details__char-arrow">
                              <svg viewBox="0 0 24 24" width="16" height="16">
                                <path d="M9 18l6-6-6-6" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
                              </svg>
                            </div>
                          </div>
                        )
                      })}
                    </div>
                  )}
                </div>
              )}

              {/* Actions Tab */}
              {activeTab === 'actions' && (
                <div className="client-details__actions">
                  <h4 className="client-details__actions-title">
                    <AdminActionsIcon /> Admin Actions
                  </h4>
                    <div className="client-details__actions-grid">
                      {/* Manage Tabs */}
                      <button
                        className="client-details__action-btn client-details__action-btn--gold"
                        onClick={() => setTabsModalOpen(true)}
                      >
                        <div className="client-details__action-icon">
                          <svg viewBox="0 0 24 24" width="24" height="24">
                            <defs>
                              <linearGradient id="tabIconGoldAction" x1="0%" y1="0%" x2="100%" y2="100%">
                                <stop offset="0%" stopColor="#fef3c7"/>
                                <stop offset="50%" stopColor="#fbbf24"/>
                                <stop offset="100%" stopColor="#f59e0b"/>
                              </linearGradient>
                            </defs>
                            <rect x="2" y="4" width="20" height="16" rx="2.5" fill="url(#tabIconGoldAction)" stroke="#92400e" strokeWidth="1.5"/>
                            <rect x="2" y="4" width="20" height="4" rx="2.5" fill="rgba(0,0,0,0.15)"/>
                            <circle cx="5.5" cy="6" r="0.8" fill="#ef4444"/>
                            <circle cx="8" cy="6" r="0.8" fill="#fbbf24"/>
                            <circle cx="10.5" cy="6" r="0.8" fill="#10b981"/>
                          </svg>
                        </div>
                        <div className="client-details__action-text">
                          <span className="client-details__action-title">Manage Tabs</span>
                          <span className="client-details__action-desc">Add or remove client tabs</span>
                        </div>
                      </button>

                      {/* Ban/Unban */}
                      {clientData?.isActive ? (
                        <button
                          className="client-details__action-btn client-details__action-btn--danger"
                          onClick={handleBanClick}
                        >
                          <div className="client-details__action-icon">
                            <svg viewBox="0 0 24 24" width="24" height="24">
                              <defs>
                                <linearGradient id="banGradAction" x1="0%" y1="0%" x2="100%" y2="100%">
                                  <stop offset="0%" stopColor="#fca5a5"/>
                                  <stop offset="100%" stopColor="#ef4444"/>
                                </linearGradient>
                              </defs>
                              <circle cx="12" cy="12" r="10" fill="url(#banGradAction)" stroke="#991b1b" strokeWidth="1.5"/>
                              <path d="M8 8l8 8M16 8l-8 8" stroke="#fff" strokeWidth="2.5" strokeLinecap="round"/>
                            </svg>
                          </div>
                          <div className="client-details__action-text">
                            <span className="client-details__action-title">Ban Client</span>
                            <span className="client-details__action-desc">Suspend or permanently ban</span>
                          </div>
                        </button>
                      ) : !clientData?.isEmailVerified ? (
                        <div className="client-details__action-btn client-details__action-btn--disabled">
                          <div className="client-details__action-icon">
                            <svg viewBox="0 0 24 24" width="24" height="24">
                              <defs>
                                <linearGradient id="inactiveGradAction" x1="0%" y1="0%" x2="100%" y2="100%">
                                  <stop offset="0%" stopColor="#9ca3af"/>
                                  <stop offset="100%" stopColor="#6b7280"/>
                                </linearGradient>
                              </defs>
                              <circle cx="12" cy="12" r="10" fill="url(#inactiveGradAction)" stroke="#4b5563" strokeWidth="1.5"/>
                              <path d="M12 8v5M12 16v.01" stroke="#fff" strokeWidth="2" strokeLinecap="round"/>
                            </svg>
                          </div>
                          <div className="client-details__action-text">
                            <span className="client-details__action-title">Inactive Account</span>
                            <span className="client-details__action-desc">Waiting for email verification</span>
                          </div>
                        </div>
                      ) : (
                        <button
                          className="client-details__action-btn client-details__action-btn--success"
                          onClick={handleActivateClient}
                        >
                          <div className="client-details__action-icon">
                            <svg viewBox="0 0 24 24" width="24" height="24">
                              <defs>
                                <linearGradient id="unbanGradAction" x1="0%" y1="0%" x2="100%" y2="100%">
                                  <stop offset="0%" stopColor="#86efac"/>
                                  <stop offset="100%" stopColor="#22c55e"/>
                                </linearGradient>
                              </defs>
                              <circle cx="12" cy="12" r="10" fill="url(#unbanGradAction)" stroke="#166534" strokeWidth="1.5"/>
                              <path d="M8 12l3 3 5-5" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
                            </svg>
                          </div>
                          <div className="client-details__action-text">
                            <span className="client-details__action-title">Unban Client</span>
                            <span className="client-details__action-desc">Restore client access</span>
                          </div>
                        </button>
                      )}

                      {/* Delete Client */}
                      <button
                        className="client-details__action-btn client-details__action-btn--delete"
                        onClick={handleDeleteClick}
                      >
                        <div className="client-details__action-icon">
                          <svg viewBox="0 0 24 24" width="24" height="24">
                            <defs>
                              <linearGradient id="deleteGradAction" x1="0%" y1="0%" x2="100%" y2="100%">
                                <stop offset="0%" stopColor="#fda4af"/>
                                <stop offset="100%" stopColor="#ef4444"/>
                              </linearGradient>
                            </defs>
                            <path d="M9 3h6l1 2h4v2H4V5h4l1-2z" fill="url(#deleteGradAction)" stroke="#7f1d1d" strokeWidth="0.8"/>
                            <rect x="6" y="8" width="12" height="13" rx="2" fill="url(#deleteGradAction)" stroke="#7f1d1d" strokeWidth="0.8"/>
                            <path d="M10 11v6M14 11v6" stroke="#fff" strokeWidth="1.5" strokeLinecap="round"/>
                          </svg>
                        </div>
                        <div className="client-details__action-text">
                          <span className="client-details__action-title">Delete Client</span>
                          <span className="client-details__action-desc">Permanently remove account</span>
                        </div>
                      </button>

                      {/* Edit Details */}
                      <button
                        className="client-details__action-btn client-details__action-btn--edit"
                        onClick={() => {
                          setEditUsername(client.username)
                          setEditEmail(client.email)
                          setEditDetailsModalOpen(true)
                        }}
                      >
                        <div className="client-details__action-icon">
                          <svg viewBox="0 0 24 24" width="24" height="24">
                            <defs>
                              <linearGradient id="editGradAction" x1="0%" y1="0%" x2="100%" y2="100%">
                                <stop offset="0%" stopColor="#93c5fd"/>
                                <stop offset="100%" stopColor="#3b82f6"/>
                              </linearGradient>
                            </defs>
                            <path d="M16 3l5 5L7 22H2v-5L16 3z" fill="url(#editGradAction)" stroke="#1e40af" strokeWidth="1.5" strokeLinejoin="round"/>
                          </svg>
                        </div>
                        <div className="client-details__action-text">
                          <span className="client-details__action-title">Edit Details</span>
                          <span className="client-details__action-desc">Change username or email</span>
                        </div>
                      </button>

                      {/* Verify Email */}
                      {!clientData?.isEmailVerified && (
                        <button
                          className="client-details__action-btn client-details__action-btn--success"
                          onClick={handleVerifyEmail}
                        >
                          <div className="client-details__action-icon">
                            <svg viewBox="0 0 24 24" width="24" height="24">
                              <defs>
                                <linearGradient id="verifyGradAction" x1="0%" y1="0%" x2="100%" y2="100%">
                                  <stop offset="0%" stopColor="#86efac"/>
                                  <stop offset="100%" stopColor="#22c55e"/>
                                </linearGradient>
                              </defs>
                              <path d="M22 7l-9 9-5-4" fill="none" stroke="url(#verifyGradAction)" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                              <rect x="2" y="4" width="20" height="16" rx="2" fill="none" stroke="url(#verifyGradAction)" strokeWidth="1.5"/>
                            </svg>
                          </div>
                          <div className="client-details__action-text">
                            <span className="client-details__action-title">Verify Email</span>
                            <span className="client-details__action-desc">Manually mark email as verified</span>
                          </div>
                        </button>
                      )}

                      {/* Reset Password */}
                      <button
                        className="client-details__action-btn client-details__action-btn--warning"
                        onClick={() => {
                          setResetPasswordValue('')
                          setResetPasswordModalOpen(true)
                        }}
                      >
                        <div className="client-details__action-icon">
                          <svg viewBox="0 0 24 24" width="24" height="24">
                            <defs>
                              <linearGradient id="resetPwGradAction" x1="0%" y1="0%" x2="100%" y2="100%">
                                <stop offset="0%" stopColor="#fcd34d"/>
                                <stop offset="100%" stopColor="#f59e0b"/>
                              </linearGradient>
                            </defs>
                            <rect x="5" y="11" width="14" height="10" rx="2" fill="url(#resetPwGradAction)" stroke="#92400e" strokeWidth="1.5"/>
                            <path d="M8 11V8a4 4 0 118 0v3" fill="none" stroke="url(#resetPwGradAction)" strokeWidth="2" strokeLinecap="round"/>
                            <circle cx="12" cy="16" r="1.5" fill="#92400e"/>
                          </svg>
                        </div>
                        <div className="client-details__action-text">
                          <span className="client-details__action-title">Reset Password</span>
                          <span className="client-details__action-desc">Set a temporary password</span>
                        </div>
                      </button>

                      {/* Revoke Sessions */}
                      <button
                        className="client-details__action-btn client-details__action-btn--warning"
                        onClick={handleRevokeSessions}
                      >
                        <div className="client-details__action-icon">
                          <svg viewBox="0 0 24 24" width="24" height="24">
                            <defs>
                              <linearGradient id="revokeGradAction" x1="0%" y1="0%" x2="100%" y2="100%">
                                <stop offset="0%" stopColor="#fca5a5"/>
                                <stop offset="100%" stopColor="#f97316"/>
                              </linearGradient>
                            </defs>
                            <path d="M4 4l16 16M20 4L4 20" stroke="url(#revokeGradAction)" strokeWidth="2.5" strokeLinecap="round"/>
                            <circle cx="12" cy="12" r="9" fill="none" stroke="url(#revokeGradAction)" strokeWidth="1.5"/>
                          </svg>
                        </div>
                        <div className="client-details__action-text">
                          <span className="client-details__action-title">Force Logout</span>
                          <span className="client-details__action-desc">Revoke all active sessions</span>
                        </div>
                      </button>

                      {/* Edit License Notes */}
                      <button
                        className="client-details__action-btn client-details__action-btn--edit"
                        onClick={() => {
                          setEditLicenseNotesValue(license?.notes || '')
                          setEditLicenseNotesModalOpen(true)
                        }}
                      >
                        <div className="client-details__action-icon">
                          <svg viewBox="0 0 24 24" width="24" height="24">
                            <defs>
                              <linearGradient id="notesGradAction" x1="0%" y1="0%" x2="100%" y2="100%">
                                <stop offset="0%" stopColor="#c4b5fd"/>
                                <stop offset="100%" stopColor="#8b5cf6"/>
                              </linearGradient>
                            </defs>
                            <rect x="3" y="3" width="18" height="18" rx="2" fill="url(#notesGradAction)" stroke="#5b21b6" strokeWidth="1.5"/>
                            <line x1="7" y1="8" x2="17" y2="8" stroke="#fff" strokeWidth="2" strokeLinecap="round"/>
                            <line x1="7" y1="12" x2="17" y2="12" stroke="#fff" strokeWidth="2" strokeLinecap="round"/>
                            <line x1="7" y1="16" x2="13" y2="16" stroke="#fff" strokeWidth="2" strokeLinecap="round"/>
                          </svg>
                        </div>
                        <div className="client-details__action-text">
                          <span className="client-details__action-title">License Notes</span>
                          <span className="client-details__action-desc">Edit license observations</span>
                        </div>
                      </button>
                    </div>
                </div>
              )}
            </div>
          )}
        </div>
      </Modal>

      {/* Character Detail Modal */}
      <CharacterModal 
        isOpen={characterModalOpen}
        onClose={closeCharacterModal}
        characterName={selectedCharacter?.name}
        characterWorld={selectedCharacter?.world}
        characterData={selectedCharacter}
      />

      {/* Tabs Management Modal */}
      <TabsModal 
        isOpen={tabsModalOpen}
        onClose={() => {
          setTabsModalOpen(false)
          fetchClientData() // Refresh data after tabs change
        }}
        client={client}
      />

      {/* Ban Modal */}
      <BanModal
        isOpen={banModalOpen}
        onClose={() => setBanModalOpen(false)}
        client={client}
        onConfirm={handleBanConfirm}
      />

      {/* Delete Confirmation Modal */}
      <Modal
        isOpen={deleteModalOpen}
        onClose={() => {
          setDeleteModalOpen(false)
          setDeleteConfirmText('')
        }}
        title="⚠️ Confirm Client Deletion"
        modalClassName="delete-confirm-modal"
      >
        <div className="delete-confirm-content">
          <div className="delete-confirm-warning">
            <svg viewBox="0 0 24 24" width="48" height="48">
              <defs>
                <linearGradient id="warnDeleteGradClient" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" stopColor="#fde68a" />
                  <stop offset="100%" stopColor="#f59e0b" />
                </linearGradient>
              </defs>
              <path d="M1 21h22L12 2 1 21z" fill="url(#warnDeleteGradClient)" stroke="#92400e" strokeWidth="1.5"/>
              <rect x="11" y="8" width="2" height="7" rx="1" fill="#78350f" />
              <circle cx="12" cy="18" r="1.2" fill="#78350f" />
            </svg>
          </div>
          
          <h3 className="delete-confirm-title">
            This action cannot be undone!
          </h3>
          
          <p className="delete-confirm-message">
            You are about to permanently delete the client <strong>{client?.username}</strong>.
            This will remove all associated data including:
          </p>
          
          <ul className="delete-confirm-list">
            <li>User account and credentials</li>
            <li>All characters owned by this user</li>
            <li>License information</li>
            <li>Activity history and logs</li>
          </ul>
          
          <div className="delete-confirm-input-section">
            <label htmlFor="delete-confirm-input-client" className="delete-confirm-label">
              Type <code className="delete-confirm-code">{client?.username}</code> to confirm:
            </label>
            <input
              id="delete-confirm-input-client"
              type="text"
              className="delete-confirm-input"
              value={deleteConfirmText}
              onChange={(e) => setDeleteConfirmText(e.target.value)}
              placeholder={`Type "${client?.username}" here`}
              autoComplete="off"
              autoFocus
            />
          </div>
          
          <div className="delete-confirm-actions">
            <button
              type="button"
              className="delete-confirm-btn delete-confirm-btn--cancel"
              onClick={() => {
                setDeleteModalOpen(false)
                setDeleteConfirmText('')
              }}
            >
              Cancel
            </button>
            <button
              type="button"
              className="delete-confirm-btn delete-confirm-btn--delete"
              onClick={handleDeleteConfirm}
              disabled={deleteConfirmText !== client?.username}
            >
              <svg viewBox="0 0 24 24" width="16" height="16">
                <path d="M9 3h6l1 2h4v2H4V5h4l1-2z" fill="currentColor"/>
                <rect x="7" y="8" width="10" height="13" rx="2" fill="currentColor"/>
                <path d="M10 11v6M14 11v6" stroke="#1a1a1a" strokeWidth="1.5" strokeLinecap="round"/>
              </svg>
              Delete Forever
            </button>
          </div>
        </div>
      </Modal>

      {/* Revoke Sessions Modal */}
      <Modal
        isOpen={revokeModalOpen}
        onClose={() => {
          setRevokeModalOpen(false)
          setRevokeConfirmText('')
        }}
        title="🚫 Force Logout"
        modalClassName="revoke-modal"
      >
        <div className="revoke__content">
          <div className="revoke__warning-icon">
            <svg viewBox="0 0 24 24" width="56" height="56">
              <defs>
                <linearGradient id="revokeWarnGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" stopColor="#fca5a5"/>
                  <stop offset="100%" stopColor="#ef4444"/>
                </linearGradient>
              </defs>
              <circle cx="12" cy="12" r="10" fill="none" stroke="url(#revokeWarnGrad)" strokeWidth="2"/>
              <line x1="12" y1="7" x2="12" y2="13" stroke="url(#revokeWarnGrad)" strokeWidth="2.5" strokeLinecap="round"/>
              <circle cx="12" cy="17" r="1.2" fill="url(#revokeWarnGrad)"/>
            </svg>
          </div>

          <h3 className="revoke__title">
            Revoke all active sessions for <strong>{client?.username}</strong>?
          </h3>

          <div className="revoke__sessions-summary">
            {sessionsHistory.length > 0 ? (
              <>
                <div className="revoke__session-type">
                  <span className="revoke__session-dot revoke__session-dot--app"></span>
                  <span>{sessionsHistory.filter(s => s.isActive && s.type === 'app').length} APP session(s)</span>
                </div>
                <div className="revoke__session-type">
                  <span className="revoke__session-dot revoke__session-dot--site"></span>
                  <span>{sessionsHistory.filter(s => s.isActive && s.type === 'site').length} Site session(s)</span>
                </div>
                <div className="revoke__session-total">
                  Total: <strong>{sessionsHistory.filter(s => s.isActive).length} active session(s)</strong>
                </div>
              </>
            ) : (
              <div className="revoke__session-total">No active sessions found</div>
            )}
          </div>

          <p className="revoke__desc">
            The client will be immediately disconnected from all devices
            and will need to log in again.
          </p>

          <div className="revoke__confirm-section">
            <label className="revoke__confirm-label">
              Type <code className="revoke__confirm-code">CONFIRM</code> to proceed:
            </label>
            <input
              type="text"
              className="revoke__confirm-input"
              value={revokeConfirmText}
              onChange={(e) => setRevokeConfirmText(e.target.value)}
              placeholder='Type "CONFIRM" here'
              autoComplete="off"
              autoFocus
            />
          </div>

          <div className="revoke__actions">
            <button
              type="button"
              className="revoke__btn revoke__btn--cancel"
              onClick={() => {
                setRevokeModalOpen(false)
                setRevokeConfirmText('')
              }}
            >
              Cancel
            </button>
            <button
              type="button"
              className="revoke__btn revoke__btn--revoke"
              onClick={handleRevokeConfirm}
              disabled={revokeConfirmText !== 'CONFIRM'}
            >
              <svg viewBox="0 0 24 24" width="16" height="16">
                <path d="M4 4l16 16M20 4L4 20" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/>
              </svg>
              Revoke All Sessions
            </button>
          </div>
        </div>
      </Modal>

      {/* Edit Details Modal */}
      <Modal
        isOpen={editDetailsModalOpen}
        onClose={() => setEditDetailsModalOpen(false)}
        title="✏️ Edit Client Details"
        modalClassName="edit-details-modal"
      >
        <div className="edit-details__form">
          <div className="edit-details__current">
            <div className="edit-details__current-title">Current Values</div>
            <div className="edit-details__current-row">
              <span className="edit-details__current-label">Username:</span>
              <span className="edit-details__current-value">{client.username}</span>
            </div>
            <div className="edit-details__current-row">
              <span className="edit-details__current-label">Email:</span>
              <span className="edit-details__current-value">{client.email}</span>
            </div>
          </div>
          <div className="edit-details__field">
            <label className="edit-details__label">
              <svg viewBox="0 0 24 24" width="16" height="16" className="edit-details__field-icon">
                <circle cx="12" cy="8" r="4" fill="none" stroke="currentColor" strokeWidth="1.5"/>
                <path d="M4 21c0-4 3.5-7 8-7s8 3 8 7" fill="none" stroke="currentColor" strokeWidth="1.5"/>
              </svg>
              New Username
            </label>
            <input
              type="text"
              className="edit-details__input"
              value={editUsername}
              onChange={(e) => setEditUsername(e.target.value)}
              placeholder={client.username}
              autoComplete="off"
            />
          </div>
          <div className="edit-details__field">
            <label className="edit-details__label">
              <svg viewBox="0 0 24 24" width="16" height="16" className="edit-details__field-icon">
                <rect x="2" y="4" width="20" height="16" rx="2" fill="none" stroke="currentColor" strokeWidth="1.5"/>
                <path d="M2 6l10 7 10-7" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
              </svg>
              New Email
            </label>
            <input
              type="email"
              className="edit-details__input"
              value={editEmail}
              onChange={(e) => setEditEmail(e.target.value)}
              placeholder={client.email}
              autoComplete="off"
            />
          </div>
          <div className="edit-details__actions">
            <button
              type="button"
              className="edit-details__btn edit-details__btn--cancel"
              onClick={() => setEditDetailsModalOpen(false)}
            >
              Cancel
            </button>
            <button
              type="button"
              className="edit-details__btn edit-details__btn--save"
              onClick={handleEditDetails}
              disabled={!editUsername.trim() || !editEmail.trim()}
            >
              <svg viewBox="0 0 24 24" width="16" height="16">
                <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              Save Changes
            </button>
          </div>
        </div>
      </Modal>

      {/* Reset Password Modal */}
      <Modal
        isOpen={resetPasswordModalOpen}
        onClose={() => {
          setResetPasswordModalOpen(false)
          setShowPassword(false)
        }}
        title="🔑 Reset Password"
        modalClassName="reset-pw-modal"
      >
        <div className="reset-pw__form">
          <div className="reset-pw__warning">
            <svg viewBox="0 0 24 24" width="20" height="20">
              <path d="M12 2L2 19h20L12 2z" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
              <line x1="12" y1="9" x2="12" y2="14" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
              <circle cx="12" cy="17" r="0.8" fill="currentColor"/>
            </svg>
            <span>This will instantly change the client's password. They will be unable to log in with their old password.</span>
          </div>
          <div className="reset-pw__field">
            <label className="reset-pw__label">New Temporary Password</label>
            <div className="reset-pw__input-group">
              <input
                type={showPassword ? 'text' : 'password'}
                className="reset-pw__input"
                value={resetPasswordValue}
                onChange={(e) => setResetPasswordValue(e.target.value)}
                placeholder="Min 6 characters"
                autoComplete="off"
                autoFocus
              />
              <button
                type="button"
                className="reset-pw__toggle"
                onClick={() => setShowPassword(!showPassword)}
                tabIndex={-1}
                title={showPassword ? 'Hide password' : 'Show password'}
              >
                {showPassword ? (
                  <svg viewBox="0 0 24 24" width="18" height="18">
                    <path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19M14.12 14.12a3 3 0 11-4.24-4.24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    <line x1="1" y1="1" x2="23" y2="23" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                  </svg>
                ) : (
                  <svg viewBox="0 0 24 24" width="18" height="18">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    <circle cx="12" cy="12" r="3" fill="none" stroke="currentColor" strokeWidth="1.5"/>
                  </svg>
                )}
              </button>
            </div>
            {resetPasswordValue.length > 0 && (
              <div className="reset-pw__strength">
                <div className="reset-pw__strength-bar">
                  <div
                    className={`reset-pw__strength-fill ${
                      resetPasswordValue.length < 6 ? 'reset-pw__strength-fill--weak' :
                      resetPasswordValue.length < 10 ? 'reset-pw__strength-fill--medium' :
                      'reset-pw__strength-fill--strong'
                    }`}
                    style={{
                      width: `${
                        resetPasswordValue.length < 6 ? (resetPasswordValue.length / 6) * 33 :
                        resetPasswordValue.length < 10 ? 33 + ((resetPasswordValue.length - 6) / 4) * 33 :
                        66 + Math.min((resetPasswordValue.length - 10) / 10, 1) * 34
                      }%`
                    }}
                  />
                </div>
                <span className="reset-pw__strength-label">
                  {resetPasswordValue.length < 6 ? 'Weak' :
                   resetPasswordValue.length < 10 ? 'Medium' :
                   'Strong'}
                </span>
              </div>
            )}
            <p className="reset-pw__hint">The client will need to use this password on next login</p>
          </div>
          <div className="reset-pw__actions">
            <button
              type="button"
              className="reset-pw__btn reset-pw__btn--cancel"
              onClick={() => {
                setResetPasswordModalOpen(false)
                setShowPassword(false)
              }}
            >
              Cancel
            </button>
            <button
              type="button"
              className="reset-pw__btn reset-pw__btn--confirm"
              onClick={() => {
                handleResetPassword()
                setShowPassword(false)
              }}
              disabled={!resetPasswordValue || resetPasswordValue.length < 6}
            >
              <svg viewBox="0 0 24 24" width="16" height="16">
                <rect x="5" y="11" width="14" height="10" rx="2" fill="none" stroke="currentColor" strokeWidth="1.5"/>
                <path d="M8 11V8a4 4 0 118 0v3" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
              </svg>
              Reset Password
            </button>
          </div>
        </div>
      </Modal>

      {/* Edit License Notes Modal */}
      <Modal
        isOpen={editLicenseNotesModalOpen}
        onClose={() => setEditLicenseNotesModalOpen(false)}
        title="📝 Edit License Notes"
        modalClassName="edit-notes-modal"
      >
        <div className="edit-notes__form">
          <div className="edit-notes__info">
            Current permanent tabs: <strong>{license?.summary?.permanentTabs || license?.tabs || 0}</strong>
            {license?.summary?.activePackages > 0 && (
              <span> · Active packages: <strong>{license.summary.activePackages}</strong></span>
            )}
          </div>
          <div className="edit-notes__field">
            <label className="edit-notes__label">License Notes</label>
            <textarea
              className="edit-notes__textarea"
              value={editLicenseNotesValue}
              onChange={(e) => setEditLicenseNotesValue(e.target.value)}
              placeholder="e.g., payment terms, special conditions, support notes..."
              rows={5}
              autoFocus
            />
            <div className="edit-notes__counter">
              <span className={editLicenseNotesValue.length > 500 ? 'edit-notes__counter--over' : ''}>
                {editLicenseNotesValue.length}
              </span> / 500 characters
            </div>
          </div>
          <div className="edit-notes__actions">
            <button
              type="button"
              className="edit-notes__btn edit-notes__btn--cancel"
              onClick={() => setEditLicenseNotesModalOpen(false)}
            >
              Cancel
            </button>
            <button
              type="button"
              className="edit-notes__btn edit-notes__btn--save"
              onClick={handleEditLicenseNotes}
            >
              <svg viewBox="0 0 24 24" width="16" height="16">
                <path d="M19 21H5a2 2 0 01-2-2V5a2 2 0 012-2h11l5 5v11a2 2 0 01-2 2z" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
                <polyline points="17,21 17,13 7,13 7,21" fill="none" stroke="currentColor" strokeWidth="1.5"/>
                <polyline points="7,3 7,8 14,8" fill="none" stroke="currentColor" strokeWidth="1.5"/>
              </svg>
              Save Notes
            </button>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default ClientDetailsModal
